import { createSelector } from 'reselect';

export const selectEditor = createSelector(store => store, store => store.editor);
export const selectDirty = createSelector(selectEditor, store => store.dirty);
export const selectException = createSelector(selectEditor, store => store.exception);
export const selectFocus = createSelector(selectEditor, store => store.focus);
export const selectMode = createSelector(selectEditor, store => store.mode);
export const selectModeData = createSelector(selectEditor, store => store.modeData[store.mode]);
export const selectProject = createSelector(selectEditor, store => store.project);
export const selectSearchText = createSelector(selectEditor, store => store.searchText);
export const selectTitle = createSelector(selectEditor, store => store.title);
export const selectHelpAvailable = createSelector(selectEditor, store => store.helpAvailable);
export const selectUserId = createSelector(selectEditor, store => store.userId);
export const selectActiveGroup = createSelector(selectEditor, store => store.activeGroup);
export const selectWriterMode = createSelector(selectEditor, store => store.writerMode);
